import { createLucideIcon } from 'lucide-react';
export const LogsManagementIcon = createLucideIcon('logs-management', [
  [
    'path',
    {
      d: 'M10 11.5V8.5H22V16.5H13.5',
      key: '16ldqz',
    },
  ],
  [
    'path',
    {
      d: 'M13.5 13.5L8 16.5L2 13.8339',
      key: 'jn0wdo',
    },
  ],
  [
    'path',
    {
      d: 'M13.5 13.5V11.5H2V13.8339',
      key: '2w8bmj',
    },
  ],
  [
    'path',
    {
      d: 'M13.5 13.5V16.8339V20L2 19.8972V13.8339',
      key: '1po46p',
    },
  ],
  [
    'path',
    {
      d: 'M18 12H20',
      key: 'sdy7w7',
    },
  ],
  [
    'path',
    {
      d: 'M5 11.5V4H16.3676V8.5',
      key: '1l1kts',
    },
  ],
]);
